import type { ListBuilderList } from '../../../types';
import { createShopStandardColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Recommended list configuration
 *
 * The real account recommender (PD-14016/14017): items precomputed
 * nightly for THIS account from its own purchase history (cosine
 * item-to-item affinity → client_item_recommendation table). Falls back
 * to the legacy "not purchased + >=3 distinct customers" heuristic only
 * while the account has no precomputed rows yet — see the `recommended`
 * case in client-item.service.ts. Tenant-wide popularity now lives in
 * the separate "Popular" tab (shop-popular.ts).
 *
 * The `in_stock` filter is included by default because recommending
 * out-of-stock items wastes a click — the user can't add them to a
 * cart.
 *
 * Kept aligned with the Item Insights "Recommended" tab
 * (clients.service.ts:getRecommendedItems) so the two surfaces show
 * the same set of items per PD-13622 / PD-13453.
 */
export const shopRecommendedList: ListBuilderList = {
	id: 'shop_recommended',
	cacheTTL: 600000,
	name: 'Recommended',
	type: 'default',
	active: true,
	sortOrder: 6,
	columns: createShopStandardColumns(),
	description: 'AI-recommended items for the client',
	defaultSortId: 'column-item_details-asc',
	requiredFields: SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'recommended',
					label: 'Recommended',
				},
				{
					id: 'in_stock',
					label: 'In Stock',
				},
			],
		},
	},
};
